import React from 'react';

import Table from 'components/Table';
import Avatar from 'components/Avatar';
import {formatDateTime} from 'utils/datetime';
import MoreOptions from 'components/MoreOptions';

import './styles.css';

const UserCell = ({
  user: {fullName, avatarCropped, internalAvatarCropped, email, initials}
}) => (
  <div className="userCell">
    <Avatar url={internalAvatarCropped || avatarCropped} initials={initials} />
    <div className="info">
      <div className="name">{fullName}</div>
      <div className="email">{email}</div>
    </div>
  </div>
);

const ModelInstancesTable = ({modelInstances}) => (
  <div className="ModelInstancesTable">
    <header className="header">
      <h3>Model Instances</h3>
    </header>

    <div className="tableContainer">
      <div className="tableHeader">
        <Table>
          <Table.Header>
            <Table.HeaderItem className="id" heading={'id'} />
            <Table.HeaderItem className="modelType" heading={'Model Type'} />
            <Table.HeaderItem className="createdAt" heading={'Created At'} />
            <Table.HeaderItem className="createdBy" heading={'Created By'} />
            <Table.HeaderItem className="more" />
          </Table.Header>
        </Table>
      </div>
      <div className="tableBody">
        <Table>
          <Table.Body>
            {modelInstances.map((modelInstance, index) => (
              <Table.Row key={index}>
                <Table.Cell className="id">{modelInstance.id}</Table.Cell>
                <Table.Cell className="modelType">
                  {modelInstance.modelType}
                </Table.Cell>
                <Table.Cell className="createdAt">
                  {formatDateTime(modelInstance.createdAt)}
                </Table.Cell>
                <Table.Cell className="name">
                  {modelInstance.createdBy && (
                    <UserCell user={modelInstance.createdBy} />
                  )}
                  {!modelInstance.createdBy && 'N/A'}
                </Table.Cell>
                <Table.Cell className="more">
                  <MoreOptions openInNewTab url={modelInstance.link} />
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
    </div>
  </div>
);

export default ModelInstancesTable;
